import type { IKeyGroupByCategory } from '../interfaces/configCat.interfaces';

export const defaultSdkKeys: IKeyGroupByCategory = {
  config: {
    testing: process.env.DEFAULT_TEST_CONFIG_SDK_KEY,
    testingKenya: process.env.DEFAULT_TEST_CONFIG_SDK_KEY,
    stagingKenya: process.env.DEFAULT_STG_CONFIG_SDK_KEY,
    staging: process.env.DEFAULT_STG_CONFIG_SDK_KEY,
    productionKenya: process.env.DEFAULT_PROD_CONFIG_SDK_KEY,
  },
  featureFlag: {
    testing: process.env.DEFAULT_TEST_FF_SDK_KEY,
    testingKenya: process.env.DEFAULT_TEST_FF_SDK_KEY,
    stagingKenya: process.env.DEFAULT_STG_FF_SDK_KEY,
    staging: process.env.DEFAULT_STG_FF_SDK_KEY,
    productionKenya: process.env.DEFAULT_PROD_FF_SDK_KEY,
  },
};
